import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { TipoDePropostaEnum } from "../enums/enums";
import { ProdutoEnum } from "../enums/produto.enum";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import { HubResponse } from "../interfaces/hub-response.interface";
import {
	IAlterProposalRequest,
	IAproveProposalRequest,
	IBureauSearch,
	ICalcBillingProposalJudicial,
	ICalcPremioPropostaAdiantamento,
	IDueDate,
	IEmailSendModel,
	IEmitirApoliceProposalRequest,
	IImprimirProposalRequest,
	IProposalAtualizaStatus,
	IProposalJudicial,
	IProposalRequest,
	IProposalRequestByCode,
	IProposalRequestByCodeI4pro,
	IProposalResponse,
	IRequestExpirationDate,
	IRequestInsuredPermission,
	IRequestProposalInitialDateRange,
	ISearchInsuredByName
} from "../interfaces/proposal.interface";
import { IResponseListDataPaginate } from "../interfaces/response-data.interface";
import { PostProposalTermViewModel, ProposalTermViewModel } from "../viewmodels/proposal-term.viewmodel";
@Injectable({
	providedIn: "root"
})
export class ProposalService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(request: IProposalRequest): Observable<IResponseListDataPaginate<IProposalResponse>> {
		return this.http.post<IResponseListDataPaginate<IProposalResponse>>(
			`${environment.urlApi}/Proposal/GetByFilter`,
			request
		);
	}

	getFilters(request: IProposalRequest): Observable<IResponseListDataPaginate<any>> {
		return this.http.post<IResponseListDataPaginate<any>>(`${environment.urlApi}/Proposal/Filter`, request);
	}

	getPolicyExpDateCalculated(request: IRequestExpirationDate): Observable<any> {
		return this.http.post<IRequestExpirationDate>(`${environment.urlApi}/Proposal/GetPolicyExpDateCalculated`, request);
	}

	getChangeInitialDateProposal(request: IRequestExpirationDate): Observable<any> {
		return this.http.post<IRequestExpirationDate>(`${environment.urlApi}/Proposal/ChangeInitialDateProposal`, request);
	}

	getDataDeExpiracaoJudicial(request): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposta/GetDataDeExpiracaoJudicial`, request);
	}

	getTypesProposals(tipoDeProduto = 0): Observable<any> {
		let params = new HttpParams();
		if (tipoDeProduto !== null) params = params.append("idTipoSetor", tipoDeProduto.toString());

		return this.http.get<any>(`${environment.urlApi}/Proposal/GetAllProposalType`, { params });
	}

	GetProposalTypes(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetProposalTypes`);
	}

	GetPropostaSetor(tipoProposta): Observable<any> {
		let params = new HttpParams();
		if (tipoProposta !== null) params = params.append("idTipoProposta", tipoProposta.toString());

		return this.http.get<any>(`${environment.urlApi}/ProposalType/GetPropostaSetor`, { params });
	}

	getCommercialStructure(idProduto: number): Observable<any> {
		let params = new HttpParams();
		if (idProduto !== null) {
			params = params.append("productId", idProduto.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/Proposal/GetCommercialStructure`, { params });
	}

	getDataValidadeAndLimiteCreditoTomador(idPessoaTomador: number): Observable<any> {
		let params = new HttpParams();
		if (idPessoaTomador !== null) {
			params = params.append("idPessoaTomador", idPessoaTomador.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/I4Pro/BuscarLimiteCreditoAndValidadeCadastroTomador`, { params });
	}

	getCommercialStructureJudicial(idProduto: number, idTipoDeProposta: number): Observable<any> {
		let params = new HttpParams();
		if (idProduto !== null) {
			params = params.append("productId", idProduto.toString());
		}
		if (idTipoDeProposta !== null) {
			params = params.append("idTipoDeProposta", idTipoDeProposta.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetCommercialStructureJudicial`, { params });
	}

	GetCommercialStructureUser(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetCommercialStructureUser`);
	}

	getCommercialEntityStructure(commercialStructureId: number): Observable<any> {
		let params = new HttpParams();
		if (commercialStructureId !== null) {
			params = params.append("commercialStructureId", commercialStructureId.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/Proposal/CommercialEntityStructure`, { params });
	}

	getParametroTomador(idTipoDeProposta: number, idTomador: number, depositoRecursal?: any): Observable<any> {
		let params = new HttpParams();
		if (idTipoDeProposta !== null) {
			params = params.append("idTipoDeProposta", idTipoDeProposta.toString());
		}
		if (idTomador !== null) {
			params = params.append("idTomador", idTomador.toString());
		}
		if (depositoRecursal) {
			params = params.append("depositoRecursal", depositoRecursal.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/ParameterTaker/GetParameterTomador`, { params });
	}

	postProposalDuplicate(id: number): Observable<any> {
		let params = new HttpParams();
		if (id !== null) {
			params = params.append("proposalById", id.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/Proposal/ProposalDuplicate`, { params });
	}

	getInsuredObjectDescriptionList(id): Observable<any> {
		let params = new HttpParams();
		if (id !== null) params = params.append("id", id.toString());

		return this.http.get<any>(`${environment.urlApi}/Proposal/GetInsuredObject`, { params });
	}

	getInsuredObjectbyId(id, legado = true, isProposalCreate = false): Observable<any> {
		let params = new HttpParams();
		if (id !== null) params = params.append("id", id.toString());
		params = params.append("legado", legado.toString());
		params = params.append("isProposalCreate", isProposalCreate.toString());
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetInsuredObjectById`, { params });
	}

	getI4ProGetFrequencyPayByProductCd(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetFrequencyPay`, { params });
	}

	getI4ProGetFrequencyPayByProductCdSME(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetFrequencyPaySME`, { params });
	}

	getI4ProGetParcelingByProductCd(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetParceling`, { params });
	}

	getBureauById(id): Observable<any> {
		let params = new HttpParams();
		if (id && id > 0) {
			params = params.append("id", id.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetBureauById`, { params });
	}

	getRegistryBureauById(id): Observable<any> {
		let params = new HttpParams();
		if (id && id > 0) {
			params = params.append("id", id.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetRegistryBureauById`, { params });
	}

	getI4ProGetParcelingByProductCdSME(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetParcelingSME`, { params });
	}

	getI4ProListComplaninerType(): Observable<any> {
		const params = new HttpParams();
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetRecursalType`, { params });
	}

	GetComplainerByProposal(idProposal): Observable<any> {
		let params = new HttpParams();
		if (idProposal !== null) {
			params = params.append("proposalId", idProposal.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetComplainerByProposal`, { params });
	}

	getAllLegalRecourseType(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetAllLegalRecourseType`);
	}

	getI4ProLegalRecourseTypeParameter(legalRecourseTypeId): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/I4Pro/GetLegalRecourseTypeParameter?legalRecourseTypeId=${legalRecourseTypeId}`
		);
	}

	getInsuredPermission(insuredData: IRequestInsuredPermission): Observable<HubResponse<any>> {
		return this.http.get<HubResponse<any>>(
			`${environment.urlApi}/Proposal/GetInsuredPermission?insuredId=${insuredData.insuredId}&cdProduto=${insuredData.cdProduto}`
		);
	}

	getProposalById(id: number): Observable<any> {
		let params = new HttpParams();

		if (id && id > 0) {
			params = params.append("proposalById", id.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/Proposal/GetProposalById`, { params });
	}

	getProposalJudicialById(id: number): Observable<any> {
		let params = new HttpParams();

		if (id && id > 0) {
			params = params.append("id", id.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/PropostaJudicial/GetPropostaJudicialById`, { params });
	}

	getI4ProGetBureauItens(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetBureauItens`);
	}

	getPropostaDiasNaoUteis(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/PropostaDiasNaoUteis`);
	}

	getPropostaDiasPagamento(inicioVigencia: string, fimVigencia: string): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/Proposal/PropostaDiasNaoUteis?inicioVigencia=${inicioVigencia}&fimVigencia=${fimVigencia}`
		);
	}

	getI4ProGetRegistryBureau(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetRegistryBureau`);
	}

	removeProposalById(id: number): Observable<any> {
		let params = new HttpParams();
		if (id && id > 0) {
			params = params.append("id", id.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/Proposal/RemoveProposalById`, { params });
	}

	geti4RecursalPolicyExp() {
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetRecursalPolicyExp`);
	}

	getDateRange(request: IRequestProposalInitialDateRange) {
		return this.http.post<any>(`${environment.urlApi}/Proposta/GetDataPeriodoProposta`, request);
	}

	obterParametrosDeData(idTipoDeProposta: number) {
		return this.http.get<any>(`${environment.urlApi}/proposaltype/${idTipoDeProposta}/dateValidityParameters`);
	}

	//POST
	getProposalByCodeI4Pro(request: IProposalRequestByCodeI4pro): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/Code`, request);
	}

	sendEmail(request: IEmailSendModel): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/PropostaJudicial/SendMailCheckComercial`, request);
	}

	sendEmailTomador(request: IEmailSendModel): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/PropostaJudicial/SendMailCheckTomador`, request);
	}

	sendEmailUnavailableLimitIS(request: IEmailSendModel): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Mail/SendUnavailableLimitIS`, request);
	}

	getProposalByCode(request: IProposalRequestByCode): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetProposalByCode`, request);
	}

	deleteCDA(idCda): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/PropostaJudicial/RemovePropostaJudicialCda?idCda=${idCda}`);
	}

	getProposalByCodeJudicial(request: IProposalRequestByCode): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetProposalByCodeJudicial`, request);
	}

	postAproveProposal(request: IAproveProposalRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/AproveProposal`, request);
	}

	patchVoltarParaEdicao(request): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/Proposal/PutProposalBackEdit`, request);
	}

	putAtualizarStatus(request: IProposalAtualizaStatus): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/PropostaJudicial/AtualizarStatus`, request);
	}

	getImprimirMinuta(request: IImprimirProposalRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetPdfProposalMinuta`, request);
	}

	getImprimirApolice(request: IImprimirProposalRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetPdfProposalApolice`, request);
	}

	getImprimirBoleto(request: IImprimirProposalRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetProposalApoliceImprimirBoleto`, request);
	}

	getTakerByBroker(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetTakerByBroker`, request);
	}

	getProposalByCodeJudicialSubLimite(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetProposalByCodeJudicialSubLimite`, request);
	}

	postEmitirApolice(request: IEmitirApoliceProposalRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/EmitirApolicelI4pro`, request);
	}

	putProposalI4pro(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/PutProposalI4pro`, request);
	}

	putProposalI4proAdiantamento(request: any): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/proposal/advance`, request);
	}

	putProposal(request: IAlterProposalRequest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/Proposal/PutProposal`, request);
	}

	PutFormaPagamentoProposta(request: IAlterProposalRequest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/Proposal/PutFormaPagamentoProposta`, request);
	}

	putProposalSearch(request: any): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/Proposal/PutProposalSearch`, request);
	}

	putProposalJudicialStatusSearch(request: any): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/PropostaJudicial/AtualizarStatus`, request);
	}

	postStep1(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/Post`, request);
	}

	postStep2(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/Post/ProposalData`, request);
	}

	postStep3I4pro(request): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/PostProposalI4pro`, request);
	}

	getProposalStatusTypes(request): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetStatusProposal`, request);
	}

	getProposalStatus(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/ProposalStatus/Get`);
	}

	proposalDuplicate(id: number): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/ProposalDuplicate?proposalById=${id}`);
	}

	geti4ProPrizeValidated(request): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/I4Pro/GetPrizeValidated`, request);
	}

	getIndiceDeAtualizaoByIdTipoDeProposta(idTipoDeProposta: number): Observable<any> {
		var params = new HttpParams();
		if (idTipoDeProposta && idTipoDeProposta > 0) {
			params = params.append("idTipoDeProposta", idTipoDeProposta.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/PropostaJudicial/GetIndiceDeAtualizacaoByIdTipoDeProposta`, {
			params
		});
	}

	getKindOfActionsByIdProposalsType(id: number | string): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/PropostaJudicial/GetTiposDeAcaoByIdTipoDeProposta?idTipoDeProposta=${id}`
		);
	}

	getInsuredObjectsFromProposals() {
		return this.http.get<any>(`${environment.urlApi}/Proposta/GetPropostaJudicialObjetoSegurado`);
	}

	getProposalType() {
		return this.http.get<any>(`${environment.urlApi}/ProposalType/Get`);
	}

	getI4ProGetParcelingProposalJudicialByProductCd(id: string): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetParcelingPropostaJudicial?id=${id}`);
	}

	getI4ProGetFrequencyPayProposalJudicialByProductCd(id: string): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/I4Pro/GetFrequenciaDePagamentoPropostaJudicialByProductId?id=${id}`
		);
	}

	postCalcBillingProposalJudicial(request: ICalcBillingProposalJudicial) {
		const params = new HttpParams();
		return this.http.post<any>(`${environment.urlApi}/PropostaJudicial/EfetuarCalculo`, request);
	}

	postCalcularPremioPropostaAdiantamento(request: ICalcPremioPropostaAdiantamento) {
		return this.http.post<any>(`${environment.urlApi}/Proposta/AdiantamentoPagamento/EfetuarCalculo`, request);
	}

	postCalcBillingProposalJudicialTrabalhista(request: ICalcBillingProposalJudicial) {
		return this.http.post<any>(`${environment.urlApi}/Proposta/Judicial/Trabalhista/EfetuarCalculo`, request);
	}

	postCalcBillingProposalJudicialCivel(request: ICalcBillingProposalJudicial) {
		return this.http.post<any>(`${environment.urlApi}/Proposta/Judicial/Civel/EfetuarCalculo`, request);
	}

	getDueDateProposalJudicial({ IdTomador, codFormaPagamento }: IDueDate): Observable<any> {
		let params = new HttpParams();
		params = params.append("cd_forma_pagamento", codFormaPagamento);
		params = params.append("IdTomador", IdTomador);

		return this.http.get<any>(`${environment.urlApi}/PropostaJudicial/GetDataDeVencimentoPropostaJudicial`, { params });
	}

	getI4ProInsuredByName(payload: ISearchInsuredByName): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetI4ProInsuredByName`, payload);
	}

	postBureauSearch(request: IBureauSearch): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Bureau/Search`, request);
	}

	getBalanceAvailable(id: number, idTipoDeProposta: number): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/Balance/GetAvailable?id=${id}&idTipoDeProposta=${idTipoDeProposta}`
		);
	}

	validateCCGFormalized(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/ValidateCCGFormalized`, request);
	}

	getProposalTerm(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/GetTermByUser`, request);
	}

	postTerm(postterm: PostProposalTermViewModel): Observable<any> {
		return this.http.post<ProposalTermViewModel>(`${environment.urlApi}/Proposal/PostTerm`, postterm);
	}

	getPropostaPrazoApolicesByIdTipoDeProposta(idTipoDeProposta: number): Observable<any> {
		let params = new HttpParams();
		if (idTipoDeProposta && idTipoDeProposta > 0) {
			params = params.append("idtipoDeProposta", idTipoDeProposta.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/Proposta/Judicial/GetPropostaPrazoApolicesByIdTipoDeProposta`, {
			params
		});
	}

	getTypesProposalsRecursal(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/Proposal/GetAllProposalType`);
	}

	getTipoSetorProposta(): Observable<any> {
		return this.http.get(`${environment.urlApi}/Proposta/GetTiposSetorProposta`);
	}

	getI4ProGetParcelingByProduct(cdProduto: number): Observable<any> {
		let params = new HttpParams();
		if (cdProduto !== null) {
			params = params.append("cdProduto", cdProduto.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetI4ProGetParcelingByProduct`, { params });
	}

	GetParcelamentoProposta(cdProduto: number, premio: any): Observable<any> {
		let params = new HttpParams();

		if (cdProduto !== null && premio !== null) {
			params = params.append("cdProduto", cdProduto.toString());
			params = params.append("premio", premio.toString());
		}

		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetParcelamentoProposta`, { params });
	}

	getI4ProGetPayWayByProduct(cdProduto: number, proposalTypeId: number): Observable<any> {
		let params = new HttpParams();
		if (cdProduto !== null) {
			params = params.append("cdProduto", cdProduto.toString());
		}
		if (proposalTypeId !== null) {
			params = params.append("proposalTypeId", proposalTypeId.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetI4ProPayWayByProduct`, { params });
	}

	getI4ProGetFrequencyPayByProduct(cdProduto: number): Observable<any> {
		let params = new HttpParams();
		if (cdProduto !== null) {
			params = params.append("cdProduto", cdProduto.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/I4Pro/GetI4ProFrequencyPayByProduct`, { params });
	}

	postConsultaCCGParaEmissao(request: any): Observable<any> {
		return this.http.post<any>(
			`${environment.urlApi}/Proposta/AdiantamentoDePagamento/ConsultaCCGParaEmissao`,
			request
		);
	}

	validProposalToProceed(proposalId: number, proposalTypeId: number): Observable<any> {
		let params = new HttpParams();
		params = params.append("proposalId", proposalId.toString());
		params = params.append("proposalTypeId", proposalTypeId.toString());
		return this.http.get(`${environment.urlApi}/Proposal/ValidProposalToProceed`, { params });
	}

	getProdutoIdByTypePropostaUrlAndTipoSetorPropostaEnum(typePropostaUrl: number): number {
		let produtoId = 0;
		switch (typePropostaUrl) {
			case TipoDePropostaEnum.ContratoConstrucao:
			case TipoDePropostaEnum.ContratoFornecimento:
			case TipoDePropostaEnum.ContratoPrestacaoServicos:
			case TipoDePropostaEnum.Licitacoes:
				produtoId = ProdutoEnum.GarantiaVarejoSetorPublicoCIRC662;
				break;
			case TipoDePropostaEnum.Adiantamento:
			case TipoDePropostaEnum.ContratoPrivadoConstrucao:
			case TipoDePropostaEnum.ContratoPrivadoFornecimento:
			case TipoDePropostaEnum.ContratoPrivadoPrestacaoServicos:
				produtoId = ProdutoEnum.GarantiaVarejoSetorPrivadoCIRC662;
				break;

			case TipoDePropostaEnum.Contratos:
			case TipoDePropostaEnum.SME:
				produtoId = ProdutoEnum.GarantiaSetorPrivado;

			case TipoDePropostaEnum.LicitacoesPrivado:
			case TipoDePropostaEnum.ContratosPrivado:
				produtoId = ProdutoEnum.GarantiaObrigacoesPrivadas;
				break;

			case TipoDePropostaEnum.Recursal:
			case TipoDePropostaEnum.Civel:
			case TipoDePropostaEnum.Trabalhista:
			case TipoDePropostaEnum.Fiscal:
				produtoId = ProdutoEnum.GarantiaCorpSetorPublicoCIRC662;
				break;
		}
		return produtoId;
	}

	setProdutoCobertura(typePropostaUrl: number, tipoPropostas: any): any {
		if (typePropostaUrl === TipoDePropostaEnum.Recursal) {
			return tipoPropostas.recursal;
		} else if (typePropostaUrl === TipoDePropostaEnum.SME) {
			return tipoPropostas.recursalSme;
		}
	}

	getTipoSeguradoLabel(insuredTypeId: number): string {
		if (insuredTypeId === 1) {
			return "Reclamante";
		} else if (insuredTypeId === 2) {
			return "Tribunal";
		} else {
			return "Vara";
		}
	}

	formatArrayRecursal(array, type): any[] {
		const formatedArray = [];

		if (type === "recurso") {
			array.forEach(element => {
				formatedArray.push({
					nome: element.recursalModalityTipo
				});
			});
		} else if (type === "deposito") {
			array.forEach(element => {
				formatedArray.push({
					nome: element.recursalModalityValorDeposito.toString()
				});
			});
		}

		return formatedArray;
	}

	getTipoSeguradoId(insuredTypeLabel: string): string {
		if (insuredTypeLabel === "Reclamante") {
			return "1";
		} else if (insuredTypeLabel === "Tribunal") {
			return "2";
		}

		return "3";
	}

	validateISValue(request: any): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/Proposal/ValidateLockValueISFromProposal`, request);
	}

	getFiltersByRedis(status, lastWeek, page, pageSize): Observable<any> {
		return this.http.get<any>(
			`${environment.urlApi}/proposal/GetAllProposalByRedis?status=${status}&lastWeek=${lastWeek}&page=${page}&pageSize=${pageSize}`
		);
	}
}
